import React, { useEffect, useRef } from "react";

export default function Turnstile({ siteKey, handleTurnstile }) {
	const widgetRef = useRef(null);
	const widgetIdRef = useRef(null);

	// Render the Turnstile widget (guarded against double-render)
	const renderTurnstile = () => {
		if (widgetRef.current && window.turnstile && widgetIdRef.current === null) {
			widgetIdRef.current = window.turnstile.render(widgetRef.current, {
				sitekey: siteKey,
				callback: (token) => {
					handleTurnstile("verify", token);
				},
				"error-callback": () => {
					handleTurnstile("error", "");
				},
				"expired-callback": () => {
					handleTurnstile("expired", "");
					if (widgetIdRef.current !== null && window.turnstile) {
						window.turnstile.reset(widgetIdRef.current);
					}
				},
			});
		}
	};

	// Load the Turnstile script
	useEffect(() => {
		const scriptId = "cf-turnstile-script";

		if (!document.getElementById(scriptId)) {
			const script = document.createElement("script");
			script.id = scriptId;
			script.src =
				"https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit";
			script.async = true;
			script.defer = true;
			document.body.appendChild(script);

			script.onload = renderTurnstile;
		} else if (window.turnstile) {
			renderTurnstile();
		}

		return () => {
			if (widgetIdRef.current !== null && window.turnstile) {
				window.turnstile.remove(widgetIdRef.current);
				widgetIdRef.current = null;
			}
		};
	}, []);

	return (
		<div>
			<div ref={widgetRef} />
			{/* Optional: <button onClick={resetTurnstile}>Reset</button> */}
		</div>
	);
}
